define([
	'internal_util/Logger',
	'internal_util/Util',
	'recoverystrategy/WebstartRecoveryStrategy',
	'recoverystrategy/OpeneCardAppRecoveryStrategy',
	'recoverystrategy/ManualRecoveryStrategy',
	'recoverystrategy/CustomProtocolRecoveryStrategy',
	'service/EidClientManager',
	'service/EventListenerRegistry',
	'amdi18n-loader?!service/nls/RecoveryStrategyManager_strings'
], function (
	Logger,
	Util,
	WebstartRecoveryStrategy,
	OpeneCardAppRecoveryStrategy,
	ManualRecoveryStrategy,
	CustomProtocolRecoveryStrategy,
	EidClientManager,
	EventListenerRegistry,
	Strings
) {
	'use strict';

	/**
	 * RecoveryStrategyManager class
	 */
	return function (eidClientManager) {
		var _recoveryStrategies;

		if (eidClientManager instanceof EidClientManager) {
			_recoveryStrategies = [
					new WebstartRecoveryStrategy(eidClientManager),
					new OpeneCardAppRecoveryStrategy(eidClientManager),
					new ManualRecoveryStrategy(eidClientManager),
					new CustomProtocolRecoveryStrategy(eidClientManager)
			];
		}

		// private methods

		function log(method, message, data) {
			Logger.log('RecoveryStrategyManager', method, message, data);
		}

		// public methods

		this.getRecoveryStrategies = function (authenticationOption) {
			var _name = 'getRecoveryStrategies',
				usableRecoveryStrategies = new Array(),
				i;

			log(_name, Strings.selecting_recovery_strategies, authenticationOption);

			for (i = 0; i < _recoveryStrategies.length; i++) {
				if (!_recoveryStrategies[i].isUsable(authenticationOption)) {
					log(_name, Strings.skip_not_usable_strategy, _recoveryStrategies[i]);
					continue;
				}

				usableRecoveryStrategies.push(_recoveryStrategies[i]);
			}

			if (usableRecoveryStrategies.length === 0) {
				log(_name, Strings.no_strategy_available, _recoveryStrategies);
			}

			return usableRecoveryStrategies;
		};

		this.startRecoveryStrategy = function (recoveryStrategy, authenticationOption, callbacks, errorCallbacks) {
			var _name = 'startRecoveryStrategies';

			for (var i = 0; i < _recoveryStrategies.length; i++) {
				if (_recoveryStrategies[i] === recoveryStrategy) {
					recoveryStrategy.start(authenticationOption, callbacks, errorCallbacks);
					return;
				}
			}

			log(_name, Strings.strategy_not_found, recoveryStrategy);
		};

		this.stopRecoveryStrategies = function () {
			for (var i = 0; i < _recoveryStrategies.length; i++) {
				log('stopRecoveryStrategies', Strings.stopping_strategy, _recoveryStrategies[i]);

				_recoveryStrategies[i].stop();

				log('stopRecoveryStrategies', Strings.stopped_strategy, _recoveryStrategies[i]);
			}
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/RecoveryStrategyManager.js
// module id = 290
// module chunks = 4